import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions';
import { withRouter, Link } from 'react-router-dom';
import { CURRENCY } from '../../constants';
import { formatMoney } from '../../services';
import { detectClickOutSide as clickOutside } from '../../utils'
import './layout.css';

class LayoutNavbar extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
            btnToggleNavbarRef: createRef(),
            navbarRef: createRef()
        }
    }
    
    componentDidMount() {
        clickOutside(this.state.navbarRef, this.hadleClickToggleNavbar, ["wheel"]).didMount();
      }
      
    componentWillUnmount() {
    clickOutside(this.state.navbarRef, this.hadleClickToggleNavbar, ["wheel"]).willUnMount();
    }

    hadleClickToggleNavbar = e => {
        const { attributes } = this.state.btnToggleNavbarRef.current;
        if (
            window.innerWidth < 992 && 
            (
                attributes.hasOwnProperty("aria-expanded") && 
                attributes["aria-expanded"].value == 'true'
            )
        ) this.state.btnToggleNavbarRef.current.click();
    }

    findTotalQty = cart => {
        const initialValue = 0;
        const totalQty = typeof cart === "object" && cart.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.qty;
        }, initialValue);
        return totalQty > 0 ? totalQty : null;
    };

    findTotalPrice = (cart) => {
        const initialValue = 0;
        const subTotal = cart.reduce((accumulator, currentValue) => {
            const { price, qty } = currentValue;
            const totalPricePerItem = qty * price;
            return accumulator + totalPricePerItem;
        }, initialValue);
        return formatMoney(subTotal);
    };

    handleOnClick = () => {
        const { firebaseAuth, OpenDialogLogin, history, basenameURL } = this.props;
        history.push(`${basenameURL}/cart`);
    };

    handleFirebaseAuthSignOut = () => {
        this.props.FirebaseAuthSignOut();
        // window.location.href = window.location.origin;
    };

    submitSearch = () => {
        const { keyword, history, SearchItemFormKeyword, basenameURL } = this.props;
        if (keyword.length > 0) {
            history.push(`${basenameURL}/search?keyword=${keyword}`);
            SearchItemFormKeyword(keyword);
        }
    };

    handleSearchKeyDown = e => {
        if (e.key === 'Enter') {
            this.submitSearch();
        }
    };

    render() {
        const {
            keyword,
            cart,
            firebaseAuth,
            OpenDialogLogin,
            KeywordChange,
            navbarCategory,
            currentLanguage,
            ClearBuyNowItemInCart,
            wording,
            LanguageChange,
            basenameURL,
            buyNow
        } = this.props;
        const {
            btnToggleNavbarRef,
            navbarRef
        } = this.state;

        const itemsCart = buyNow.status ? buyNow.item: cart;

        return (
            <nav className='navbar navbar-static-top'>
                <div className='navigation'>
                    <div className='container relative'>
                        <div className='row'>
                            <div className='navbar-header'>
                                <div className='nav-cart mobile-cart right hidden-lg hidden-md'>
                                    <div className='cart-outer'>
                                        <div className='cart-inner'>
                                            <a
                                                className='pointer mr-20'
                                                onClick={() => LanguageChange(currentLanguage === 'TH' ? 'EN' : 'TH')}>
                                                <span style={{ fontSize: 15, fontWeight: 'bold' }}>
                                                    {currentLanguage}
                                                </span>
                                            </a>
                                        </div>
                                        <div className='cart-inner'>
                                            <a className='shopping-cart pointer' onClick={() => this.handleOnClick()}>
                                                <span>{itemsCart && this.findTotalQty(itemsCart)}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <button
                                    type='button'
                                    className='navbar-toggle'
                                    data-toggle='collapse'
                                    data-target='#navbar-collapse'
                                    ref={btnToggleNavbarRef}>
                                    <span className='sr-only'>Toggle navigation</span>
                                    <span className='icon-bar' />
                                    <span className='icon-bar' />
                                    <span className='icon-bar' />
                                </button>
                            </div>
                            <div className='header-wrap col-md-12'>
                                <div className='nav-search type-2 hidden-sm hidden-xs'>
                                    <div>
                                        <input
                                            type='search'
                                            className='form-control form-control-mod'
                                            placeholder={`${wording.homePage.navbar.search}...`}
                                            value={keyword}
                                            onChange={e => KeywordChange(e.target.value)}
                                            onKeyDown={this.handleSearchKeyDown}
                                        />
                                        <button className='search-button' onClick={() => this.submitSearch()}>
                                            <i className='icon icon_search' />
                                        </button>
                                    </div>
                                </div>

                                <div className='logo-container'>
                                    <div className='logo-wrap text-center'>
                                        <Link to={`${basenameURL}`}>
                                            <img
                                                className='logo'
                                                style={{ width: 100, height: 46 }}
                                                src='/assets/img/sf/sflogo_wh.png'
                                                alt='logo'
                                            />
                                        </Link>
                                    </div>
                                </div>

                                <div className='nav-cart-wrap style-2 hidden-sm hidden-xs'>
                                    <div className='nav-cart right'>
                                        <div
                                            className='nav-cart-ammount hidden-sm hidden-xs pointer'
                                            onClick={() => {
                                                ClearBuyNowItemInCart();
                                                this.handleOnClick();
                                            }}>
                                            {itemsCart && itemsCart.length > 0 ? (
                                                <span>
                                                    {`${wording.homePage.navbar.cart} / `}
                                                    {` ${CURRENCY.B}${this.findTotalPrice(itemsCart)}`}
                                                </span>
                                            ) : null}
                                        </div>
                                        <div className='cart-outer right'>
                                            <div className='cart-inner'>
                                                <a
                                                    className='shopping-cart pointer'
                                                    onClick={() => {
                                                        ClearBuyNowItemInCart();
                                                        this.handleOnClick();
                                                    }}>
                                                    <span>{itemsCart && this.findTotalQty(itemsCart)}</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-12 nav-wrap'>
                                <div className='collapse navbar-collapse' id='navbar-collapse' ref={navbarRef}>
                                    <ul className='nav navbar-nav'>
                                        {/* Search */}
                                        <li id='mobile-search' className='hidden-lg hidden-md'>
                                            <div className='mobile-search relative'>
                                                <input
                                                    type='search'
                                                    className='form-control form-control-mod'
                                                    placeholder={`${wording.homePage.navbar.search}...`}
                                                    value={keyword}
                                                    onChange={e => KeywordChange(e.target.value)}
                                                    onKeyDown={this.handleSearchKeyDown}
                                                />
                                                <button
                                                    type='submit'
                                                    className='search-button'
                                                    onClick={() => this.submitSearch()}>
                                                    <i className='icon icon_search' />
                                                </button>
                                            </div>
                                        </li>

                                        {navbarCategory.map((category, index) => {
                                            return (
                                                <li key={index} className='dropdown'>
                                                    <Link to={`${basenameURL}${category.url}`} onClick={() => this.hadleClickToggleNavbar()}>
                                                        {currentLanguage === 'EN'
                                                            ? category.categoryNameEn
                                                            : category.categoryNameTh}
                                                    </Link>
                                                </li>
                                            );
                                        })}

                                        <li className='mobile-links'>
                                            <ul>
                                                {firebaseAuth && (
                                                    <>
                                                        <li className='top-bar-link'>
                                                            <a
                                                                className='pointer dropdown-toggle'
                                                                data-toggle='dropdown'>
                                                                {firebaseAuth.displayName
                                                                    ? firebaseAuth.displayName
                                                                    : firebaseAuth.email}
                                                            </a>
                                                            <ul className='dropdown-menu'>
                                                                <li>
                                                                    <Link to={`${basenameURL}/user/address`} onClick={() => this.hadleClickToggleNavbar()}>
                                                                        {wording.homePage.topbar.myAddress}
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <Link to={`${basenameURL}/user/purchase`} onClick={() => this.hadleClickToggleNavbar()}>
                                                                        {wording.homePage.topbar.myOrder}
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <Link to={`${basenameURL}/user/return`} onClick={() => this.hadleClickToggleNavbar()}>
                                                                        {wording.homePage.topbar.myReturn}
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <Link to={`${basenameURL}/user/voucher`} onClick={() => this.hadleClickToggleNavbar()}>
                                                                        {wording.homePage.topbar.myVoucher}
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                        <li className='top-bar-link'>
                                                            <a
                                                                className='pointer'
                                                                onClick={this.handleFirebaseAuthSignOut}>
                                                                {wording.homePage.topbar.SignOut}
                                                            </a>
                                                        </li>
                                                    </>
                                                )}
                                                {!firebaseAuth && (
                                                    <li>
                                                        <a className='pointer' onClick={OpenDialogLogin}>
                                                            {wording.homePage.topbar.loginRegister}
                                                        </a>
                                                    </li>
                                                )}
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        );
    }
}

const mapStateToProps = ({ login, search, navigation, cart, language }) => ({
    firebaseAuth: login.firebaseAuth,
    isAuthenticated: login.isAuthenticated,
    navbarCategory: navigation.navbarCategory,
    keyword: search.keyword,
    cart: cart.data,
    buyNow: cart.buyNow,
    currentLanguage: language.currentLanguage,
    wording: language.wording,
    basenameURL: language.basenameURL
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            KeywordChange: Actions.KeywordChange,
            CategoryNameChange: Actions.CategoryNameChange,
            SearchItemFormKeyword: Actions.SearchItemFormKeyword,
            OpenDialogLogin: Actions.OpenDialogLogin,
            CloseDialogLogin: Actions.CloseDialogLogin,
            FirebaseAuthSignOut: Actions.FirebaseAuthSignOut,
            ClearBuyNowItemInCart: Actions.ClearBuyNowItemInCart,
            LanguageChange: Actions.LanguageChange
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LayoutNavbar));
